(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentCreatePersonalGroup, 
        ['$rootScope', '$http', '$uibModal', '$q', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, $q, authentication) {      

  		var service  = function createPersonalGroupModal(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentCreatePersonalGroup,
			    size: 'md',
			    backdrop: 'static',
			    windowClass: 'medium-Modal',
			    controller: ['$scope', '$uibModalInstance',			   
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing Create Personal Group for Students");
				
			    //initialize default settings
			    $scope.createPersonalGroupErrorMesg = "";
			    $scope.createPersonalGroupErrorOccurred = false;
			    $scope.createPersonalGroupSuccessMesg = "";
			    $scope.createPersonalGroupSuccess = false;
			    $scope.createPersonalGroupErrorValidationMesg = "";
			    $scope.createPersonalGroupErrorValidationOccurred = false;			    
			    $scope.isSaveStudentUnlockCurriculumBusy = false;	
			    $scope.createPersonalGroupForm = true;

				$scope.studentsCount = selectedStudentsCount;
				$scope.createPersonalGroup = {};
				$scope.createPersonalGroupButtonAction = true;
			   
				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};

				$scope.closeSuccessMsg = function() {
                        $scope.createPersonalGroupSuccess = false;
                }
                $scope.closeErrorMsg = function() {
                        $scope.createPersonalGroupErrorOccurred = false;
                }   

				$scope.createPersonalGroup = function(){
					resetErrorFlags();
					$scope.isSaveStudentCreatePersonalGroupBusy = true;

                    if ($scope.isFormValid()) {                    	

                    	$scope.createPersonalGroupForm = false;

                    	// The teacher Id has to be considered as a member of the group
                    	// Get all the studentsIds in an array
						var selectedStudentsIds = [];
						for (var i = 0; i < selectedStudents.length; i++) {
							selectedStudentsIds.push(selectedStudents[i].idnId);
						};
                    	selectedStudentsIds[selectedStudentsCount] =  authentication.getCurrentUser().identityid;

                    	$http({
			              	url : schoolwork12.app.student.endpoints.personalGroupUrl,
			              	method : "POST",
							data : {										
										"method": "add",
										"idntSchInfo": selectedStudents,
										"parameters": [
										    {
										      "numberStudentsInGroup": selectedStudentsIds.length,		
										      "group": {
										        "access": "PERSONAL",
										        "groupType": "DEFAULT",
										        "name": $scope.createPersonalGroup.groupName,
										        "groupStatus": "ACTIVE",
										        "description": $scope.createPersonalGroup.groupDescription
										      },
										      "memberAdditions": {
										        "submittedByIdentityID": authentication.getCurrentUser().identityid,
										        "owner": authentication.getCurrentUser().identityid,
										        "membersToAdd": selectedStudentsIds,
										        "administratorsToAdd": [],
										        "membersToRemove": [],
										        "administratorsToRemove": []
										      },
										      "clientContext": {
										        "namespace": "IDENTITY_MANAGEMENT_SERVICE",
										        "version": "1",
										        "clientIPAddress": "1.1.1.1"
										      }
										    }
										  ]
									},		
		        		  	headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).success(function (response) {
			              		console.info("Students group created successfully", response);
	            	   			$scope.createPersonalGroupErrorOccurred = false;
			              		$scope.createPersonalGroupButtonAction = false;
			              		$rootScope.actionCompletedSuccessfully = true;
	            	   			$rootScope.actionCompletedSuccessfullyMessage = response;
	            	   			$uibModalInstance.close();
			              				   					              		
			              	}).error(function(error){ 
			              		$scope.createPersonalGroupErrorOccurred = true;
			              		$scope.createPersonalGroupButtonAction = false;
			              		$scope.createPersonalGroupErrorMesg = schoolwork12.app.student.modalErrMessages.createPersonalGroupFailed + "\n";

			                	console.info('Error in creating Personal group...'.concat(angular.toJson(error)));
			                	if (error.status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.createPersonalGroupErrorMesg = $scope.createPersonalGroupErrorMesg + error.data._errors[j] + "\n";
									}
								} else if (error.status == 401 || error.status == 403) {
			                        $scope.createPersonalGroupErrorMesg = $scope.createPersonalGroupErrorMesg + schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.createPersonalGroupErrorMesg = $scope.createPersonalGroupErrorMesg + schoolwork12.app.errorMessages.internalError;
			                    }
			            	});

                    } else {
                    	$scope.isSaveStudentCreatePersonalGroupBusy = false;                    
                    }
				}

				$scope.isFormValid = function(){

					console.info("Validating Group Name");
					if ($scope.createPersonalGroup.groupName == null ||
					    $scope.createPersonalGroup.groupName== "") {
						$scope.createPersonalGroupErrorValidationOccurred = true;
						$scope.createPersonalGroupErrorValidationMesg = $scope.createPersonalGroupErrorValidationMesg +
														 schoolwork12.app.student.errorMessages.createGroupNameRequired + "\n"						
					}					

					console.info("Validating Group Description");
					if ($scope.createPersonalGroup.groupDescription == null ||
					    $scope.createPersonalGroup.groupDescription == "") {
						$scope.createPersonalGroupErrorValidationOccurred = true;
						$scope.createPersonalGroupErrorValidationMesg = $scope.createPersonalGroupErrorValidationMesg +
														 schoolwork12.app.student.errorMessages.createGroupDescriptionRequired 
						
					}

					return !$scope.createPersonalGroupErrorValidationOccurred

				}

				
                           	
				var resetErrorFlags = function() {
                    // Control Error messages 
                    $scope.createPersonalGroupErrorMesg = "";
                    $scope.createPersonalGroupErrorOccurred = false; 
                    $scope.createPersonalGroupErrorValidationMesg = "";
                    $scope.createPersonalGroupErrorValidationOccurred = false; 
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = ""                   
                }

			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));